var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMessageSent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaign",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chat_paste_go_20dp_FILL0_wght300_GRAD-25_opsz20",
    d: "M168.448-745.981h-2.962a.487.487,0,0,1-.353-.142.463.463,0,0,1-.146-.344.483.483,0,0,1,.146-.35.477.477,0,0,1,.353-.148h2.962l-1.056-1.085a.424.424,0,0,1-.162-.33.482.482,0,0,1,.161-.33.482.482,0,0,1,.353-.152.488.488,0,0,1,.353.148l1.78,1.813a.607.607,0,0,1,.184.43.594.594,0,0,1-.184.427l-1.78,1.817a.488.488,0,0,1-.353.148.482.482,0,0,1-.353-.152.482.482,0,0,1-.161-.33.424.424,0,0,1,.162-.33Zm-10.217-.246-1.574,1.578a.309.309,0,0,1-.332.056.256.256,0,0,1-.206-.256v-9.984a1.2,1.2,0,0,1,.361-.886,1.2,1.2,0,0,1,.877-.36h8.861a1.182,1.182,0,0,1,.872.363,1.2,1.2,0,0,1,.36.874v2.909a.478.478,0,0,1-.144.349.47.47,0,0,1-.346.145.478.478,0,0,1-.348-.145.475.475,0,0,1-.146-.349v-2.909a.244.244,0,0,0-.073-.18.244.244,0,0,0-.18-.073h-8.856a.242.242,0,0,0-.181.073.248.248,0,0,0-.071.18v7.631h5.174a.473.473,0,0,1,.345.144.47.47,0,0,1,.145.346.477.477,0,0,1-.145.348.47.47,0,0,1-.345.146Zm1.176-5.912h4.745a.491.491,0,0,0,.352-.142.459.459,0,0,0,.148-.344.484.484,0,0,0-.145-.35.47.47,0,0,0-.349-.148h-4.745a.481.481,0,0,0-.35.144.468.468,0,0,0-.146.346.481.481,0,0,0,.143.348A.467.467,0,0,0,159.407-752.14Zm0,2.956h2.779a.482.482,0,0,0,.349-.142.464.464,0,0,0,.145-.344.483.483,0,0,0-.145-.35.471.471,0,0,0-.349-.148h-2.779a.471.471,0,0,0-.347.144.473.473,0,0,0-.143.346.48.48,0,0,0,.143.348A.468.468,0,0,0,159.408-749.184Zm-2.3,1.971v0Z",
    transform: "translate(519.88 762.08)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessageSent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messageSent.9b329427.svg";
export { ForwardRef as ReactComponent };